module.exports = __webpack_public_path__ + "a2e6e1dcf5adfdb59f16f128615e1ebf.png";